var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StaticText',{attrs:{"value":_vm.display,"tooltip":_vm.tooltip}})
}
var staticRenderFns = []

export { render, staticRenderFns }